import {authReducer} from "./Auth";
import {menuReducer} from "./Menu";
import {combineReducers} from "redux";

export const rootReducer = combineReducers({
    orderData: authReducer,
    menuData: menuReducer
})